import { Component } from '@angular/core';

import { FieldBaseComponent } from '../base-component';
import { NgClass } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';

@Component({
  selector: 'app-lib-ff-input',
  styleUrls: ['./input.component.scss'],
  templateUrl: './input.component.html',
  imports: [
    NgClass,
    FormsModule,
    ReactiveFormsModule,
    FormlyModule,
  ],
})
export class FormlyInputFieldComponent extends FieldBaseComponent {
  public get type() {
    return this.props.type ?? 'text';
  }
}
